function isValidMBI(mbi: any) {
  // Ensure the MBI is a string
  if (typeof mbi !== "string") {
    return false;
  }

  // Convert to uppercase for validation
  mbi = mbi.toUpperCase();

  // Check length (MBI must be exactly 11 characters)
  if (mbi.length !== 11) {
    return false;
  }

  // Define excluded letters
  const excludedLetters = ['S', 'L', 'O', 'I', 'B', 'Z'];

  // Helper function to check if a character is a valid letter
  const isValidLetter = (char) =>
    /^[A-Z]$/.test(char) && !excludedLetters.includes(char);

  // Helper function to check if a character is a valid number
  const isValidNumber = (char) => /^[0-9]$/.test(char);

  // Validate each character based on its position
  return (
    /^[1-9]$/.test(mbi[0]) &&                 // 1st: Number (1-9)
    isValidLetter(mbi[1]) &&                  // 2nd: Letter
    (isValidLetter(mbi[2]) || isValidNumber(mbi[2])) && // 3rd: Letter or Number
    isValidNumber(mbi[3]) &&                  // 4th: Number (0-9)
    isValidLetter(mbi[4]) &&                  // 5th: Letter
    (isValidLetter(mbi[5]) || isValidNumber(mbi[5])) && // 6th: Letter or Number
    isValidNumber(mbi[6]) &&                  // 7th: Number (0-9)
    isValidLetter(mbi[7]) &&                  // 8th: Letter
    isValidLetter(mbi[8]) &&                  // 9th: Letter
    isValidNumber(mbi[9]) &&                  // 10th: Number (0-9)
    isValidNumber(mbi[10])                    // 11th: Number (0-9)
  );
}

export function containsValidMBI(financialInformation: any): string {
  for (const key in financialInformation) {
    const value = financialInformation[key];

    if (typeof value === "object" && value !== null) {
      const mbi = containsValidMBI(value);
      if (mbi) {
        return mbi;
      }
    } else if (typeof value === "string") {
      const words = value.trim().split(/[^A-Za-z0-9]+/).filter(word => word)
      for (const word of words) {
        if (isValidMBI(word)) {
          return word;
        }
      }
    }
  }
  return '';
}